import styles from './About.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'
import ToDownload2 from 'components/services/common/ToDownload2'
import toDownload2Styles from 'components/services/common/ToDownload2/ToDownload2.module.scss'

interface SummaryItem {
  title: string
  text: string
}

interface Props {
  list: SummaryItem[]
}

const About: React.FC<Props> = ({ list }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.summary} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>概要</h2>
      <div className={styles.summary__inner}>
        {list.map((item, index) => (
          <>
            <h3 key={index} className={styles.summary__inner__title}>
              {item.title}
            </h3>
            <p key={index} className={styles.summary__inner__item}>
              {item.text}
            </p>
          </>
        ))}
        <ToDownload2
          imgSrc="/images/img/download/design-system/thumbnail_ds.webp"
          alt="デザインシステム外注ガイド"
          title="デザインシステム外注ガイド"
          description="デザインマネージャーも安心！スケールするプロダクトのための実装から運用まで見据えた、デザインシステムの発注の際に使えるガイドラインです。是非ご覧ください。"
          link="/download/design-system/"
          subText="サービス資料"
          className={toDownload2Styles.layoutAbout}
        />
      </div>
    </section>
  )
}

export default About
